// store/shopStore.ts
import { defineStore } from 'pinia';

interface ShopState {
  cart: Array<any>;
}

export const useShopStore = defineStore('shopStore', {
  state: (): ShopState => ({
    cart: [],
  }),
  actions: {
    updateCart(new_cart: Array<any>) {
      this.cart = new_cart;
    },
  }
});
